import { defineComponent as _defineComponent } from 'vue';
import { computed, ref } from 'vue';
import { useVideoData } from '@blade-sxp/monitoring-center/pages/preview/utils/useVideoData';
import { useMonitoringStore } from '@blade-sxp/monitoring-center/store/index';
import AlarmSettingDialog from '@blade-sxp/monitoring-center/pages/components/alarm-setting-dialog.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'box-single-top',
    props: {
        item: null
    },
    emits: ['changeTask'],
    setup(__props, { emit }) {
        const props = __props;
        /**
         * box-single-top
         * 单个视频框头部可选项 组件注入注解
         * 引入方式
         * <BoxSingleTop :item="detail" />
         * 支持的props如下：
         * item {VideoItem} 当前视频框数据
         */
        const store = useMonitoringStore();
        const fullScreen = computed(() => store.fullScreen);
        const singleScreen = computed(() => store.singleScreen);
        const escfullScreenStatus = computed(() => store.escfullScreenStatus);
        const selTaskId = computed(() => props.item);
        const dialogVisible = ref(false);
        const dialogMsg = ref({});
        const { delVideoData } = useVideoData();
        const openSetting = (item) => {
            dialogVisible.value = true;
            dialogMsg.value = item;
        };
        const changeTask = (val) => {
            const videoData = store.videoDetailArr;
            const videoItem = videoData.find((video) => video.deviceId === props.item.deviceId);
            videoItem.checkId = val;
            store.updateVideoDatailData(videoData);
            emit('changeTask', val, props.item);
        };
        const gofullScreen = () => {
            store.toggleSingleScreen(true);
            store.toggleFullScreen(!fullScreen.value);
            // store.toggleEscfullScreenStatus(false);
        };
        return { __sfc: true, store, fullScreen, singleScreen, escfullScreenStatus, props, emit, selTaskId, dialogVisible, dialogMsg, delVideoData, openSetting, changeTask, gofullScreen, AlarmSettingDialog };
    }
});
